module.exports = __webpack_public_path__ + "static/media/avatar_4.0cebb0d8.svg";